// @ts-check

import store from '../../redux/store';
import { useSelector } from "react-redux";
import { makeStyles } from '@material-ui/core/styles';
import { TestModel } from './TestModels/TestModel';
import { ErrorBoundary } from './TestModels/errorBoundry';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  renderedModelContainer: {
    position: 'relative',
    top: '5px',
    // margin: '0px auto 0 auto',
    width: '100%',
    height: '90%'
  },
  model: {
    position: 'absolute',
    width: '100%',
    height: '100%'
  }
}));

function RenderedSolutionContainer(props) {
  // getting the modelView directly from the store so the component won't rerender (which would be the case with useSelector)
  const state = store.getState()

  const modelState = useSelector(state => state.model);
  const materialsState = useSelector(state => state.globalFormData.sustainability.materials) //state.globalFormData.sustainability.materials
  // const modelView = state.viewControls.modelView

  const styles = useStyles();

  const solution = modelState.renderedSolution
  const externalWallsMaterial = materialsState.find(material => material.prefix === "EW")
  // const windowMaterial = materialsState.find(material => material.prefix === "WD")

  // let lon = 34.869739
  // let lat = 32.192026

  // const options = {
  //   modelView: modelView,
  //   location: {
  //     longitude: lon,
  //     latitude: lat,
  //   },
  //   time: 1634889286000,
  //   external_wall_tile_url: externalWallsMaterial.tile_url
  //   // time: date.getTime() + (localTime * 3600000) - (timeOffset * 1000) // UTC
  // }


  // useEffect(() => {
  //   console.count('RenderSolution')

  //   let date = new Date()
  //   let lon = 34.869739
  //   let lat = 32.192026
  //   let localTime = 12
  //   let timeOffset = 0 // get from https://maps.googleapis.com/maps/api/timezone/json?location=${lat},${lon}&timestamp=0&key=${timezoneApiKey}

  //   // const externalWallsMaterial = materialsState.find(material => material.prefix === "EW")
  //   // const windowMaterial = materialsState.find(material => material.prefix === "WD")
  //   // debugger;

  //   const options = {
  //     modelView: modelView,
  //     location: {
  //       longitude: lon,
  //       latitude: lat,
  //     },
  //     // time: 1634889286000,
  //     // external_wall_tile_url: externalWallsMaterial.tile_url,
  //     // windowMaterial: windowMaterial.thumb_url,
  //     time: date.getTime() + (localTime * 3600000) - (timeOffset * 1000) // UTC
  //   }


  // }, [ state, state.viewControls.modelView]);

  return (
    <div id='solutionContainer' className={styles.renderedModelContainer}>
      {/* <div id='renderedSolution' className={styles.model}>
      </div> */}
      {/* <RenderedSolutionControls /> */}
      {
        solution &&
        <div style={{ height: 40 + "vh" }}>
          <ErrorBoundary>

            <TestModel solution={solution} material={externalWallsMaterial.tile_url} modelView={state.viewControls.modelView} ></TestModel>
          </ErrorBoundary>
        </div>
      }
    </div>
  )
}

export default RenderedSolutionContainer